export default __webpack_public_path__ + "static/media/Printer.6bc62d0e.svg";